import { useEffect, useRef } from 'react';
import './App.css';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import StartupPlatformPage from './component/StartupPlatformPage';
import AboutUs from './component/AboutUs';
import AboutFeatures from './component/AboutFeatures';
import HowItWorks from './component/HowItWorks';
import ExploreRoles from './component/ExploreRoles';
import ServiceSection from './component/ServiceSection';
import IncubationSection from './component/IncubationSection';
import SuccessStories from './component/SuccessStories';
import AppPreview from './component/AppPreview';
import ContactSupport from './component/ContactSupport';
import NextSection from './component/NextSection';
import Footer from './component/Footer';

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

function App() {

  return (
    <div>
      <StartupPlatformPage/>
      <AboutUs/>
      <AboutFeatures/>
      <HowItWorks/>
      <ExploreRoles/>
      <ServiceSection/>
      <IncubationSection/>
      <SuccessStories/>
      <AppPreview/>
      <ContactSupport/>
      <NextSection/>
      <Footer/>
    </div>
  );
}

export default App;